export const ACCESS_TOKEN = 'X-Access-Token'
export const LANGUAGE = 'language'
export const USER_INFO = 'Login_UserInfo'
export const USER_NAME = 'Login_Username'
export const USER_AUTH = 'Login_UserAuth'
